import { styled, Tab, tabClasses } from "@mui/material";

export const SwitcherButton = styled(Tab)(() => ({
  position: "relative",
  backgroundColor: "transparent",
  padding: "calc(var(--spacing)*1)",
  minHeight: "auto",
  fontSize: "var(--text-base)",
  textTransform: "none",
  fontWeight: "var(--font-weight-medium)",
  lineHeight: "var(--text-base--line-height)",
  letterSpacing: "0.15px",
  color: "var(--color-text-label)",
  borderRadius: "var(--radius-lg)",

  [`&.${tabClasses.selected}`]: {
    color: "var(--color-text-primary)",
  },
}));
